import axios from 'axios'
import { axiosConfig } from '@/config/axiosConfig.js'

export const accumulated_precp_table_ajax = (client_name, params) => {
    return axios.post(`${client_name}/rainmonitor/get_accumulated_precp/`, params, axiosConfig)  
}

export const accumulated_precp_csv_ajax = (client_name, params) => {
    return axios.post(`${client_name}/webmap/run_accumulated_rain/`, params, axiosConfig)    
}

export const tag_list_rainstation_ajax = (client_name) => {
    return axios.get(`${client_name}/webmap/get_tag_list_has_rainstation/`, axiosConfig)  
}